import data from './data';
const {isrcs,markers,duration} = data;

const PLAYLIST = 'spotify:playlist:5vTAfWxrmGd1peOaFZbCax'; // trippie 

const EXP = {
	SPOTIFYWEB: 1,
	APPLE: 2,
	SPOTIFYMOB: 3,
}

import store from '../../../store.js';

 // setup audio service
let isMobile = false;
(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) isMobile = true;})(navigator.userAgent||navigator.vendor||window.opera);
let timeout = ms => new Promise((res, rej) => setTimeout(res, ms))

class AudioService {
	constructor(startTime, tracks, dsp, gl) {
		this.startTime = startTime;

		this.gl = gl;

		// this.isrcs = tracks.isrcs;
		// this.markers = tracks.markers;
		this.isrcs = isrcs;
		this.markers = markers;

		if(dsp.id === 1 && isMobile)
			this.EXP_TYPE = 3;
		else if(dsp.id === 1 && !isMobile)
			this.EXP_TYPE = 1;
		else if(dsp.id === 2)
			this.EXP_TYPE = 2;

		this.DSP = dsp;


		this.tryingToPlay = false;

		this.spotify_player = store.state.spotify_player;
		this.apple_player = store.state.apple_player;

		this.playAudio = this.playAudio.bind(this);
		this.resync = this.resync.bind(this);
		this.getRemainingApple = this.getRemainingApple.bind(this);
		this.getTrack = this.getTrack.bind(this);

		this._onSpotifyPlayerStateChange = this._onSpotifyPlayerStateChange.bind(this);

		this.resync();

		window.spotify_player = this.spotify_player;
		window.apple_player = this.apple_player;
	}

	init() {
		// spotify
		if(this.EXP_TYPE === EXP.SPOTIFYWEB) {
			let self = this;
			initSpotifyWebPlayback(this.DSP.access_token, player => {
				self.spotify_player = player;
				self.playAudio();
			}, this._onSpotifyPlayerStateChange);

			addScript('https://sdk.scdn.co/spotify-player.js');
		}
		// apple 
		else
			this.playAudio();

		// window.callPosUpdate = arr => {
		// 	// view distance in a 2D space

		// 	// 1.288454954924333, -2.336144129100545, -22.747290323739584]
		// 	const distance = Math.sqrt(
		// 		// Math.pow(arr[0] + 40.292488016388056, 2) +
		// 		// Math.pow(arr[2] - 39.40763813306516, 2)

		// 		Math.pow(arr[0] - 1.288454954924333, 2) +
		// 		Math.pow(arr[2] + 22.747290323739584, 2)
		// 	);

		// 	let C = 1 - distance/60;
		// 	C = C < 0 ? 0 : C;

		// 	if(this.spotify_player) 
		// 		this.spotify_player.setVolume(C)
		// 	if(this.apple_player)
		// 		this.apple_player.player.volume = C;
		// }
	}

	_onSpotifyPlayerStateChange(state) {

		let track = this.getTrack(this.startTime, this.DSP.id);


		this.gl.update({
			video_url: track.video_url,
			progress: state.position / 1000,
			timestamp: state.timestamp
		})
	}

	/**
	 * play audio from dsp
	 */
	async playAudio() {
		let track;

		// So no double playing
		if(this.tryingToPlay === true) return;
		this.tryingToPlay = true;
		setTimeout(() => this.tryingToPlay = false, 2500);

		let data;

		switch(this.EXP_TYPE) {
			case EXP.APPLE:
				track = this.getTrack(this.startTime, this.DSP.id);
				data = this.getRemainingApple(this.startTime);

				let queue, playing, seeked;

				/**
		    	 * closure variable to make sure listener handle doesnt run twice
		    	 */
		    	let triggered = false;

		    	let gl = this.gl;
		    	/**
		    	 * WAIT FOR STATE TO CHANGE, BEFORE SYNCING :D
		    	 * Otherwise you get an @sourceBufferError
		    	 */
		    	this.apple_player.addEventListener('playbackStateDidChange', async e => {
					track = this.getTrack(this.startTime, this.DSP.id);

					gl.update({
						video_url: track.video_url,
						progress: apple_player.player.currentPlaybackTime,
						timestamp: Date.now()
					})

		    		if(e.state !== 2 || triggered) return;

		    		triggered = true;
		    		try {
		    			let progress = (Date.now() - data.timestamp)/1000 + data.progress/1000;

			    		await this.apple_player.player.seekToTime(progress);
			    	} catch(err) {
			    		return console.log('ERROR SEEKING',err);
			    	}

			    	this.apple_player.player.volume = 1;

			    	this.tryingToPlay = false;

		    	})

				try {
					await this.apple_player.setQueue({
				      songs: data.remaining_isrcs
				      // playlist: 'pl.062e9ccffd2b42cba4487c89088f89db'
				    })
				} catch(err) {
					return console.log('ERROR QUEUING',err);
				}

		    	// this.apple_player.player.volume = .01;

		    	try {
		    		playing = await this.apple_player.player.play();
		    	} catch(err) {
		    		return console.log('ERROR PLAYING APPLE',err);
		    	}

				break;
			case EXP.SPOTIFYWEB:
				track = this.getTrack(this.startTime, this.DSP.id);

				if(!this.spotify_player)
					await timeout(1000);

				await play({
			      playerInstance: this.spotify_player,
			      // context_uri: PLAYLIST,
			      spotify_uri: track.uri, // track.uri,
			      uris: Object.keys(isrcs).map(isrc => isrcs[isrc][1]),
			      position_ms: track.progress
			    })

				let state = await this.spotify_player.getCurrentState();

			    this.spotify_player.setVolume(.5);


				this.tryingToPlay = false;
				break;
			case EXP.SPOTIFYMOB: 
				let data = await fetch(`${store.API_URL}/is-playing?token=${this.DSP.access_token}`);
				if(data.success)
					return;

				// open pop up if not playing trippie music
				break;
		}
	}

	soundOff() {
		this.spotify_player.setVolume(0);
	}

	soundOn() {
		this.spotify_player.setVolume(1);
	}

	/**
	 * resync with damien tool
	 */
	async resync() {
		let track, time;
		/**
		 * could be an issue because of async calls?
		 */
		requestAnimationFrame(this.resync);

		switch(this.EXP_TYPE) {
			case EXP.APPLE:
				if(!this.apple_player || !this.apple_player.player) return;
				
				// track = this.getTrack(this.startTime, this.props.dsp);
				// let position = this.apple_player.player.currentPlaybackTime;
				// time = Date.now() - this.currentTrackStartTime * 0.001;

				this.gl.currentTime = this.apple_player.player.currentPlaybackTime;
				break;
			case EXP.SPOTIFYWEB:
				// track = this.getTrack(this.startTime, this.DSP.id);
				if(!this.spotify_player) return;
				let state = await this.spotify_player.getCurrentState();
				if(!state) return;

				time = state.position + (Date.now() - state.timestamp);
				this.gl.currentTime = time * 0.001;
				break;
		}
	}


	/** 
	 * gets list of remaining apple tracks
	 */
	getRemainingApple(startTime) {
		let lapsedTime = (Date.now() - startTime)
			, position = lapsedTime - Math.floor(lapsedTime / duration) * duration
			, track = {isrc: '', marker: null};

		// iterate through the markers
		Object.keys(markers).forEach((isrc, index) => {
			// if its marker is less than our current position, quit it
			if(markers[isrc] > position) return;

			// if the there is no base track
			if(!track.marker) return track = {index, isrc: isrc, marker: markers[isrc]};

			// if it's the closest to the clock
			if(markers[isrc] > track.marker) return track = {index, isrc: isrc, marker: markers[isrc]};
		})

		let remaining_isrcs = Object.keys(markers).filter(k => markers[k] > position);

		// prepend current track isrc
		if(track.isrc)
			remaining_isrcs.unshift(track.isrc);

		// convert all isrcs to apple ids
		return {remaining_isrcs: remaining_isrcs.map(isrc => isrcs[isrc][2]), timestamp: Date.now(), progress: position - track.marker};
	}

	/**
	 * get the current track, and it's current progress
	 */
	getTrack(startTime, dsp) {
		let lapsedTime = (Date.now() - startTime)
			, position = lapsedTime - Math.floor(lapsedTime / duration) * duration
			, track = {uri: '', marker: null, video_url: ''};

		// iterate through the markers
		Object.keys(markers).forEach((uri, index) => {
			// if its marker is less than our current position, quit it
			if(markers[uri] > position) return;

			// if the there is no base track
			if(!track.marker) return track = {index, uri: isrcs[uri][dsp], marker: markers[uri], video_url: isrcs[uri].video_url};

			// if it's the closest to the clock
			if(markers[uri] > track.marker) return track = {index, uri: isrcs[uri][dsp], marker: markers[uri], video_url: isrcs[uri].video_url};
		})

		return {...track, progress: position - track.marker};
	}
}

export default AudioService;

var play = ({
  uris,
  spotify_uri,
  context_uri,
  position_ms,
  playerInstance: {
    _options: {
      getOAuthToken,
      id
    }
  }
}) => new Promise((res, rej) => {
  getOAuthToken(access_token => {
    fetch(`https://api.spotify.com/v1/me/player/play?device_id=${id}`, {
      method: 'PUT',
      body: JSON.stringify({ uris, offset: {uri: spotify_uri}, position_ms }),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${access_token}`
      },
    }).then(response => {
    	res()
    })
    .catch(err => console.log('ERROR PLAYING SPOTIFY',err));
  });
});

function initSpotifyWebPlayback(oauth_token, onPlayerReady, onPlayerStateChange) {
	console.log('initializing spotify playback')
	window.onSpotifyWebPlaybackSDKReady = () => {
	  const token = oauth_token;

	  console.log('got sdk ready callback')

	  let spotify_player = new Spotify.Player({
	    name: 'storyboard',
	    getOAuthToken: cb => { cb(token); }
	  });

	  // Error handling
	  spotify_player.addListener('initialization_error', ({ message }) => { console.error(message); });
	  spotify_player.addListener('authentication_error', ({ message }) => { console.error(message); });
	  spotify_player.addListener('account_error', ({ message }) => { console.error(message); });
	  spotify_player.addListener('playback_error', ({ message }) => { console.error(message); });

	  // Playback status updates
	  // spotify_player.addListener('player_state_changed', state => { console.log('SPOTIFY STATE',state); });
	  spotify_player.addListener('player_state_changed', onPlayerStateChange);

	  // Ready
	  spotify_player.addListener('ready', ({ device_id }) => {
	  	// console.log('spotify_id', device_id)
	    onPlayerReady(spotify_player);
	  });

	  // Not Ready
	  spotify_player.addListener('not_ready', ({ device_id }) => {
	    console.log('Device ID has gone offline', device_id);
	  });

	  // Connect to the player!
	  spotify_player.connect()
	  .then(() => console.log('sp.'+Math.random().toString().substring(0,36)));
	};
}